import api from '../../../shared/utils/api';
import type {
  CompanyContext,
  AutoGenerateStatus,
  InterviewOutput,
} from '../../../types/companyContext';

export const companyContextApi = {
  getContext: async (): Promise<CompanyContext> => {
    const { data } = await api.get<CompanyContext>('/company-context');
    return data;
  },

  saveContext: async (context: Partial<CompanyContext>): Promise<CompanyContext> => {
    const { data } = await api.put<CompanyContext>('/company-context', context);
    return data;
  },

  getInterviewOutput: async (): Promise<InterviewOutput | null> => {
    try {
      const { data } = await api.get<InterviewOutput>('/company-context/interview-output');
      return data;
    } catch (err: unknown) {
      if ((err as { response?: { status?: number } })?.response?.status === 404) return null;
      throw err;
    }
  },

  triggerAutoGenerate: async (
    companyName: string,
    domain?: string,
  ): Promise<{ status: string }> => {
    const { data } = await api.post('/company-context/auto-generate', {
      company_name: companyName,
      domain,
    });
    return data;
  },

  getAutoGenerateStatus: async (): Promise<AutoGenerateStatus> => {
    const { data } = await api.get<AutoGenerateStatus>(
      '/company-context/auto-generate/status',
    );
    return data;
  },
};
